<script setup lang="ts">
  import CountrySelectQC from '@qicgroupdoha/qic-connect-ds/components/CountrySelectQC'
  import { useI18n } from 'vue-i18n'
  import type { CountryWithDetailsType } from '@/shared/types/other.types'

  interface Props {
    modelValue: CountryWithDetailsType | undefined
    countries: CountryWithDetailsType[]
    errors?: string[]
    isValid: boolean
    filterFunction: (s: string) => CountryWithDetailsType[]
  }

  const { locale } = useI18n()
  defineProps<Props>()
  defineEmits<{ (e: 'update:modelValue', value: CountryWithDetailsType): void }>()
</script>

<template>
  <CountrySelectQC
    :model-value="modelValue"
    with-input
    :label="$t('qlm_country')"
    :select-props="{
      errors,
      isValid,
      hideArrowIcon: isValid,
      name: 'country',
      filterFunction,
      locale,
    }"
    :countries="countries"
    is-filterable
    data-test="country-select"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
